var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['customs-spinner', _vm.$props.classes, {
      hide: _vm.hide
    }],
    style: _vm.customStyles
  });
}
var staticRenderFns = []

export { render, staticRenderFns }